import { newToolFilterOAuthMcp } from "../oauth.ts";

export const netlifyMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.netlify.com/favicon/icon.svg",
  url: "https://netlify-mcp.netlify.app/mcp",
  label: "Netlify",
});
